import { generateIconComponent } from './icons.utils';

export const SearchLightIcon = generateIconComponent({
    name: 'SearchLightIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M1.59997 8.79985C1.59997 4.83032 4.83032 1.59997 8.79985 1.59997C12.7694 1.59997 15.9997 4.83032 15.9997 8.79985C15.9997 12.7694 12.7694 15.9997 8.79985 15.9997C4.83032 15.9997 1.59997 12.7694 1.59997 8.79985ZM23.766 22.6332L15.5581 14.427C16.8317 12.9006 17.5997 10.9374 17.5997 8.79985C17.5997 3.94873 13.6526 0 8.79985 0C3.94713 0 0 3.94873 0 8.79985C0 13.651 3.94713 17.5997 8.79985 17.5997C10.939 17.5997 12.9006 16.8317 14.427 15.5581L22.6348 23.766C22.7916 23.9212 22.9964 23.9996 23.1996 23.9996C23.4044 23.9996 23.6092 23.9212 23.766 23.766C24.078 23.4524 24.078 22.9468 23.766 22.6332Z" />
    ),
});
